/**
 * Kent Traders Search Analytics
 * Tracks search behavior and provides insights
 */

(function() {
  'use strict';
  
  class SearchAnalytics {
    constructor() {
      this.searchEvents = [];
      this.init();
    }
    
    init() {
      this.trackSearchSubmissions();
      this.trackFilterUsage();
      this.trackResultClicks();
      this.trackNoResults();
    }
    
    trackSearchSubmissions() {
      const searchForms = document.querySelectorAll('form[action*="/search"]');
      
      searchForms.forEach(form => {
        form.addEventListener('submit', (e) => {
          const searchTerm = form.querySelector('input[name="q"]')?.value;
          const searchType = form.querySelector('input[name="type"]')?.value || 'product';
          
          this.logEvent('search_submitted', {
            search_term: searchTerm,
            search_type: searchType,
            timestamp: Date.now()
          });
        });
      });
    }
    
    trackFilterUsage() {
      const filterForm = document.querySelector('[data-filters-form]');
      
      if (filterForm) {
        filterForm.addEventListener('submit', (e) => {
          const formData = new FormData(filterForm);
          const filters = Object.fromEntries(formData);
          
          this.logEvent('filters_applied', {
            filters: filters,
            timestamp: Date.now()
          });
        });
      }
    }
    
    trackResultClicks() {
      document.addEventListener('click', (e) => {
        const resultCard = e.target.closest('[data-product-card], [data-article-card], [data-page-card]');
        
        if (resultCard) {
          const resultType = resultCard.dataset.productCard ? 'product' : 
                           resultCard.dataset.articleCard ? 'article' : 'page';
          
          this.logEvent('result_clicked', {
            result_type: resultType,
            position: this.getResultPosition(resultCard),
            timestamp: Date.now()
          });
        }
      });
    }
    
    trackNoResults() {
      const noResults = document.querySelector('.kt-no-results');
      
      if (noResults) {
        this.logEvent('no_results', {
          search_term: new URLSearchParams(window.location.search).get('q'),
          timestamp: Date.now()
        });
      }
    }
    
    getResultPosition(element) {
      const results = document.querySelectorAll('[data-product-card], [data-article-card], [data-page-card]');
      return Array.from(results).indexOf(element) + 1;
    }
    
    logEvent(eventType, data) {
      const event = {
        type: eventType,
        data: data,
        url: window.location.href,
        user_agent: navigator.userAgent
      };
      
      this.searchEvents.push(event);
      
      // Send to analytics endpoint (if configured)
      if (window.ktSearchAnalyticsEndpoint) {
        this.sendToAnalytics(event);
      }
      
      // Log to console in development
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        if (window.logger) {
          window.logger.log('🔍 Search Analytics:', event);
        }
      }
    }
    
    sendToAnalytics(event) {
      fetch(window.ktSearchAnalyticsEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(event)
      }).catch(error => {
        console.warn('Failed to send search analytics:', error);
      });
    }
    
    getSearchStats() {
      return {
        total_searches: this.searchEvents.filter(e => e.type === 'search_submitted').length,
        total_filters: this.searchEvents.filter(e => e.type === 'filters_applied').length,
        total_clicks: this.searchEvents.filter(e => e.type === 'result_clicked').length,
        no_results: this.searchEvents.filter(e => e.type === 'no_results').length
      };
    }
  }
  
  // Initialize search analytics
  window.ktSearchAnalytics = new SearchAnalytics();
  
})();